namespace Gamification.Gamification {
    export interface RaccomandazioniForm {
        Nome: Serenity.StringEditor;
        Messaggio: Serenity.StringEditor;
        Condizione: Serenity.TextAreaEditor;
        CondizioneVerificata: Serenity.TextAreaEditor;
        Bonus: Serenity.TextAreaEditor;
    }

    export class RaccomandazioniForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.Raccomandazioni';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RaccomandazioniForm.init)  {
                RaccomandazioniForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;

                Q.initFormType(RaccomandazioniForm, [
                    'Nome', w0,
                    'Messaggio', w0,
                    'Condizione', w1,
                    'CondizioneVerificata', w1,
                    'Bonus', w1
                ]);
            }
        }
    }
}
